export const uploadFiles = (model: any) => {
    const files = model.getFiles();

    // Ensure filepicker has been configured before we use it
    const filepickerClient = Nut.modules.Global.init.configureFilePicker();

    const filestackOptions = {
        ...files.pickOptions,
        storeTo: files.storeOptions,
        // @ts-expect-error
        onUploadDone(newFiles) {
            // @ts-expect-error
            newFiles.filesUploaded.forEach((file) => files.unshift(file));
            files.saveNew();
        },
        // @ts-expect-error
        onFileUploadFailed(file, error) {
            // eslint-disable-next-line no-console
            console.error('FilePicker error', error, 'for file', file);
            // @ts-expect-error
            if (typeof window.trackJs !== 'undefined') {
                // @ts-expect-error
                window.trackJs.track(
                    `FilePicker error: ${error.message} -- ${error.details} -- ${error.stack}`
                );
            }
        },
    } as const;

    try {
        filepickerClient.picker(filestackOptions).open();
    } catch (error: any) {
        // eslint-disable-next-line no-console
        console.error(error.message, error.details);
        // @ts-expect-error
        if (typeof window.trackJs !== 'undefined') {
            // @ts-expect-error
            window.trackJs.track(`${error.message}: ${JSON.stringify(error.details)}`);
        }
    }
};
